import { render } from "./TheLoader.vue?vue&type=template&id=a14a9b72"
import script from "./TheLoader.vue?vue&type=script&lang=js"
export * from "./TheLoader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Codes\\Single Pages\\Artytech\\old_hp\\artytech_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__